// extracted by mini-css-extract-plugin
export default {"default":"button_default__-2Rg7","narrow":"button_narrow__SpbE6","transparent":"button_transparent__YebdC","textBlack":"button_textBlack__htHR0","error":"button_error__dSc9z"};